<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="infoLabelTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="coverPath" slot-scope="data">
          <img class="table-img" v-if="data.row.coverPath && data.row.coverPath.length > 0" :src="imgUrl + data.row.coverPath">
        </template>
      </wt-form-table-list>
    </wt-form-table>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="30%"
      :modal="false"
      append-to-body
      class="min-dialog-wrap"
      :show-close="false"
      :before-close="handleClose">
      <div v-if="dialogVisible" class="dialog-input-card">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
          <el-form-item label="标签名称:" prop="name" required>
            <el-input type="text" v-model="ruleForm.name"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import request from '@/utils/request'

export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_INFOLABEL',
        formComponent: {
          list: { type: 'default', value: '/modules/informationType/informationTypeList' },
          delete: { type: 'default', value: '/modules/informationType/informationTypeDelete' }
        },
        formInputsData: [
          { name: '搜索标签', key: 'name', value: '', type: 'text' },
          { name: '创建时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '新增', key: 'ADDITEM', action: 'ADDITEM', className: 'primary', hidden: false, permission: 'ADD' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '资讯标签', key: 'name', type: 'text' },
          { name: '创建时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '创建人', key: 'createUserName', type: 'text' }],
        formTableButtonsData: [{ name: '编辑', key: 'EDITITEM', action: 'EDITITEM', className: 'primary', hidden: false, permission: 'EDIT' },
          { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false, permission: 'DELETE' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true }
      },
      dialogVisible: false,
      ruleForm: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入标签名称', trigger: 'blur' },
          { min: 1, max: 20, message: '标签名称长度不能超过20', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      console.log('data', data)
      if (data && data.item) {
        if (data.item.action === 'ADDITEM') {
          this.ruleForm = {
            name: ''
          }
          this.dialogVisible = true
        }
        if (data.item.action === 'EDITITEM') {
          this.ruleForm = JSON.parse(JSON.stringify(data.row))
          this.dialogVisible = true
        }
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    submitForm(formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.createTime) {
            request({
              url: '/modules/informationType/informationTypeUpdate',
              method: 'post',
              data: this.ruleForm
            }).then(res => {
              if (res.code === '0') {
                that.$message({ message: '编辑标签成功', type: 'success' })
                this.$refs.infoLabelTableRef.requestList()
                that.handleClose()
              }
            })
          } else {
            request({
              url: '/modules/informationType/informationTypeAdd',
              method: 'post',
              data: {
                createUserId: this.userId,
                name: this.ruleForm.name
              }
            }).then(res => {
              if (res.code === '0') {
                that.$message({ message: '新增标签成功', type: 'success' })
                this.$refs.infoLabelTableRef.requestList()
                that.handleClose()
              }
            })
          }
        } else { return false }
      })
    }
  },
  computed: {
    ...mapState({
      userId: state => state.auth.userId
    })
  }
}
</script>
